import { Component, OnInit, ViewChild, ElementRef, Renderer2, OnDestroy } from '@angular/core';
import { ParamsVendas } from '../models/params-vendas';
import { Router, ActivatedRoute } from '@angular/router';

import { environment } from '../../../environments/environment';
import { ParamsVendasService } from './params-vendas.service';
import { LoaderService } from 'src/app/loader/loader.service';
import * as moment from 'moment';
import { Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';
import { PermissionsService } from 'src/app/services/permissions.service';

@Component({
  selector: 'app-params-vendas',
  templateUrl: './params-vendas.component.html',
  styleUrls: ['./params-vendas.component.scss'],
})
export class ParamsVendasComponent implements OnInit, OnDestroy {
  env;
  params: ParamsVendas;
  timeoutIDSuccess;
  timeoutIDError;

  private unsubscribe$ = new Subject();

  @ViewChild('alertSuccess', { read: ElementRef, static: false })
  alertSuccess: ElementRef;

  @ViewChild('alertError', { read: ElementRef, static: false })
  alertError: ElementRef;

  constructor(
    private router: Router,
    private route: ActivatedRoute,
    private paramsService: ParamsVendasService,
    private renderer: Renderer2,
    private loaderService: LoaderService,
    public permissionsService: PermissionsService
  ) {
    this.env = environment;
  }

  ngOnInit() {
    this.route.params.pipe(takeUntil(this.unsubscribe$)).subscribe(params => {
      if (this.permissionsService.isPermitted('settings')) {
        this.getParams(this.env.selected.cnpj);
      } else {
        this.router.navigateByUrl(`/dash/${params.cnpj}`);
      }
    });
  }

  onSubmit() {
    this.handleSubmitData();
    this.updateParams(this.params.cnpj, this.params);
  }

  addSuccessAlert(msg: string) {
    clearTimeout(this.timeoutIDSuccess);

    this.renderer.setProperty(this.alertSuccess.nativeElement, 'innerHTML', msg);
    this.renderer.setProperty(this.alertSuccess.nativeElement, 'hidden', false);

    this.timeoutIDSuccess = setTimeout(_ => {
      this.renderer.setProperty(this.alertSuccess.nativeElement, 'hidden', true);
    }, 10000);
  }

  addErrorAlert(msg: string) {
    clearTimeout(this.timeoutIDError);

    this.renderer.setProperty(this.alertError.nativeElement, 'innerHTML', msg);
    this.renderer.setProperty(this.alertError.nativeElement, 'hidden', false);

    this.timeoutIDError = setTimeout(_ => {
      this.renderer.setProperty(this.alertError.nativeElement, 'hidden', true);
    }, 10000);
  }

  async getParams(cnpj: string) {
    const loader = await this.loaderService.notifica({
      title: 'Buscando parâmetros...',
      date: moment().toISOString(),
      type: 'loading',
    });

    this.params = await this.paramsService.getParams(cnpj).toPromise();

    if (!this.params) {
      this.newParams(cnpj);
    }

    loader.dismiss();
  }

  async updateParams(cnpj: string, params: ParamsVendas) {
    const loader = await this.loaderService.notifica({
      title: 'Atualizando parâmetros...',
      date: moment().toISOString(),
      type: 'loading',
    });

    const updatedParams = await this.paramsService.updateParams(cnpj, params).toPromise();

    if ('err' in updatedParams) {
      this.addErrorAlert(updatedParams.err);
    } else {
      this.addSuccessAlert(`Parâmetros do CNPJ ${updatedParams.cnpj} atualizados com sucesso.`);
    }

    loader.dismiss();
  }

  handleSubmitData() {
    if (!this.params.percentDesconto || this.params.percentDesconto.trim().length === 0) {
      this.params.percentDesconto = null;
    }
  }

  newParams(cnpj: string) {
    this.params = {
      cnpj,
      isentaadesao: false,
      quantidadeparcelaisenta: false,
      qtadiantamento: null,
      vendedorisenta: false,
      percentDesconto: null,
      primeiropagamento: null,
      customizaPlano: false,
      itensAdbyben: false,
      limitebenalimenta: null,
      limitesegurovida: null,
      limitebenambos: null,
      recorrisentaadesao: false,
      transacaoVerificacao: false,
      portabilidadeisenta: false,
      editaVenda: false,
    };
  }

  changeIsentaAdesao(value: boolean) {
    if (!value) {
      this.params.quantidadeparcelaisenta = false;
      this.params.qtadiantamento = null;
      this.params.vendedorisenta = false;
    }
  }

  changeQtdParcIsenta(value: boolean) {
    if (!value) {
      this.params.qtadiantamento = null;
    }
  }

  changeCustomPlano(value: boolean) {
    if (!value) {
      this.params.itensAdbyben = false;
    }
  }

  changeEdiSale(value: boolean) {
    console.log(this.params);
    console.log(value);
  }

  goBack(): void {
    this.router.navigateByUrl(`/settings/${this.env.selected.cnpj}`);
  }

  _parseInt(value: string): number {
    return parseInt(value);
  }

  ngOnDestroy(): void {
    this.unsubscribe$.next();
    this.unsubscribe$.complete();
  }
}
